// src/activities/cape-vr/cape-vr-views/cape-vr-files/cape-vr-form-files/InstabilitiesEvaluation.jsx

import { useFixedTForResource } from '../../../../../locales/useFixedTForResource';
import { variableTranslations } from '../../../../../constants/variableTranslations';

function InstabilitiesEvaluation({
  selectedInstabilities,
  setSelectedInstabilities,
  instabilitiesValues,
  setInstabilitiesValues,
}) {
  const t = useFixedTForResource('CAPEVR');

  const handleCheckboxChange = (instability) => {
    if (selectedInstabilities.includes(instability)) {
      setSelectedInstabilities(selectedInstabilities.filter((item) => item !== instability));
      const updatedValues = { ...instabilitiesValues };
      delete updatedValues[instability];
      setInstabilitiesValues(updatedValues);
    } else {
      const translationKey = variableTranslations[instability] || instability;
      const attributeName = instability === 'otherInstability'
        ? instabilitiesValues?.otherInstability?.attributeName || ''
        : t(translationKey);
      setSelectedInstabilities([...selectedInstabilities, instability]);
      setInstabilitiesValues({
        ...instabilitiesValues,
        [instability]: {
          attributeName,
        },
      });
    }
  };

  const handleTextChange = (e) => {
    const newText = e.target.value;
    const hasText = newText.trim() !== '';
    setSelectedInstabilities(current => hasText
      ? current.includes('otherInstability') ? current : [...current, 'otherInstability']
      : current.filter(item => item !== 'otherInstability'));
    setInstabilitiesValues({
      ...instabilitiesValues,
      otherInstability: {
        ...instabilitiesValues.otherInstability,
        attributeName: newText,
      },
    });
  };

  return (
    <div className="capevr-radio-group">
      <label className="capevr-radio-label">{t('instabilities')}:</label>
      <div className="capevr-checkboxes-horizontal">
        {[
          'aphonicBreak',
          'pitchBreak',
          'pitchInstability',
          'spasm',
          'tremor',
          'otherInstability',
        ].map((value) => {
          const translationKey = variableTranslations[value] || value;
          return (
            <label key={value} className="capevr-checkbox-label-inline">
              <input
                type="checkbox"
                name={value}
                value={value}
                checked={selectedInstabilities.includes(value)}
                onChange={() => handleCheckboxChange(value)}
              />
              {t(translationKey)}
              {value === 'otherInstability' && (
                  <input
                    type="text"
                    id="otherInstabilityTag"
                    value={instabilitiesValues?.otherInstability?.attributeName || ''}
                    onChange={handleTextChange}
                    placeholder={t('specify')}
                    aria-label={t('other_instability')}
                    className="app-input capevr-input-inline"
                  />
                )}
            </label>
          );
        })}
      </div>
    </div>
  );
}

export default InstabilitiesEvaluation;
